<template>
  <div :class="`term term-${type}`"></div>
</template>

<script>
  import { gsap } from "gsap";

  import $ from "jquery";

  export default {
    name: "Terms",
    components: {},

    props: {
      term: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: () => "",
      },
    },

    data() {
      return {
        index: "",
        currentTerm: 0,
        totalTerms: 0,
      };
    },

    mounted() {
      this.index = $(this.$el).index();
      this.totalTerms = this.term.length;
      setTimeout(() => {
        this.initAnimation();
      }, 1000);
    },

    methods: {
      initAnimation() {
        // get the term from props object and set text in dom
        $(this.$el).text(this.term[this.currentTerm]);
        this.animateIn();
      },

      animateIn() {
        gsap.to(this.$el, {
          duration: 0.5,
          opacity: 1,
          ease: "sine.easeInOut",
          delay: 0.2 * this.index,
          onComplete: () => this.animateInComplete(),
        });
      },

      animateInComplete() {
        setTimeout(() => {
          this.animateOut();
        }, 10000);
      },

      animateOut() {
        gsap.to(this.$el, {
          duration: 0.5,
          opacity: 0,
          delay: 0.1,
          ease: "sine.easeInOut",
          onComplete: () => this.animateOutComplete(),
        });
      },

      animateOutComplete() {
        // count up current term
        this.currentTerm++;
        if (this.currentTerm > this.totalTerms) {
          this.currentTerm = 0;
        }

        this.initAnimation();
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .term {
    width: 100%;
    position: absolute;
    color: rgba(0, 0, 0, 0.4);
    opacity: 0;
  }

  .term-links {
    top: 50%;
    left: -50%;
    margin-left: -5.8em;
    text-align: center;
    margin-top: 10px;
  }

  .term-rechts {
    top: 50%;
    right: -50%;
    margin-right: -5.2em;
    text-align: center;
    margin-top: 10px;
  }

  .term-progressief {
    top: 0;
    margin-top: -3em;
    text-align: center;
  }

  .term-conservatief {
    bottom: 0;
    margin-bottom: -6.2em;
    text-align: center;
  }
</style>
